import React from 'react';
import { ListChecks, Moon, ShieldCheck, Gift, Flame } from 'lucide-react';
import { SectionHeader, Button } from '../ui/Shared';
export function BonusesSection() {
  const bonuses = [{
    icon: <ListChecks className="w-6 h-6 text-accent" data-id="element-74" />,
    title: 'Lista Negra del Reflujo',
    desc: 'La guía rápida para detectar los alimentos y combinaciones que más suelen disparar agrura, inflamación y subida de ácido.',
    value: '29 USD',
    image: 'https://i.postimg.cc/zfZDggQJ/libro-bono-1.webp'
  }, {
    icon: <Moon className="w-6 h-6 text-accent" data-id="element-75" />,
    title: 'Guía Express de Cena Sin Castigo',
    desc: 'Un esquema listo para usar con horarios, cantidades y estructura de cena para que dejes de acostarte convertido en una bomba de tiempo.',
    value: '19 USD',
    image: 'https://i.postimg.cc/90nCFR9p/libro-bono-2.webp'
  }, {
    icon: <ShieldCheck className="w-6 h-6 text-accent" data-id="element-76" />,
    title: 'Protocolo de Emergencia Anti-Agrura',
    desc: 'Una respuesta rápida para esos momentos en que el reflujo te agarra de sorpresa y te deja desesperado.',
    value: '19 USD',
    image: 'https://i.postimg.cc/mDdG8z8K/libro-bono-3.webp'
  }];
  return <section id="bonos" className="py-24 bg-surface" data-id="element-77">
      <div className="max-w-[1100px] mx-auto px-6" data-id="element-78">
        <SectionHeader tag="Bonos exclusivos" title={<>
              3 guías adicionales
              <br data-id="element-80" />
              incluidas hoy
            </>} subtitle="Recibe estas tres guías complementarias sin costo adicional al acceder al Protocolo SOS Reflujo 11 PM." data-id="element-79" />

        <div className="stagger-children grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-12" data-id="element-81">
          {bonuses.map((bono, idx) => <div key={idx} className="bg-secondary border border-white/10 rounded-2xl overflow-hidden relative transition-all duration-300 hover:-translate-y-1 hover:border-accent/30" data-id="element-82">
              <span className="absolute top-4 right-4 z-10 bg-gradient-gold text-primary text-[11px] font-extrabold py-1 px-3.5 rounded-full tracking-wider" data-id="element-83">
                HOY GRATIS
              </span>

              <div className="relative bg-gradient-to-b from-accent/5 to-transparent p-6 pb-4 flex justify-center" data-id="element-84">
                <img src={bono.image} alt={bono.title} className="w-64 md:w-72 h-auto object-contain drop-shadow-[0_16px_40px_rgba(232,160,32,0.3)] rounded-md" data-id="element-85" />
              </div>

              <div className="p-7 pt-2 md:p-8 md:pt-2" data-id="element-86">
                <h3 className="text-lg font-bold mb-2.5 text-text-light" data-id="element-87">
                  {bono.title}
                </h3>
                <p className="text-sm text-text-muted leading-relaxed mb-4" data-id="element-88">
                  {bono.desc}
                </p>
                <div className="flex items-center gap-3 mb-1" data-id="element-89">
                  <span className="price-struck text-sm font-semibold" data-id="element-90">
                    {bono.value}
                  </span>
                  <span className="text-xs text-text-muted" data-id="element-91">Valor normal</span>
                </div>
                <div className="text-lg font-extrabold text-success flex items-center gap-1.5" data-id="element-92">
                  <Gift className="w-4 h-4" data-id="element-93" /> ¡GRATIS HOY!
                </div>
              </div>
            </div>)}
        </div>

        <div className="scale-in text-center mt-12 p-8 md:p-10 bg-accent/5 border border-accent/20 rounded-xl max-w-2xl mx-auto" data-id="element-94">
          <p className="text-[15px] text-text-muted mb-2" data-id="element-95">
            Valor total real de todo lo que recibes:
          </p>
          <div className="price-struck inline-block font-playfair text-[42px] font-black text-text-muted/60 leading-none mb-3" data-id="element-96">
            187 USD
          </div>
          <p className="text-lg text-text-muted mt-2" data-id="element-97">
            Hoy lo obtienes todo por solo
          </p>
          <div className="price-glow font-playfair text-[56px] font-black text-gradient-gold leading-none mt-2" data-id="element-98">
            12 USD
          </div>
          <div className="flex justify-center mt-6" data-id="element-99">
            <Button href="#cta-final" data-id="element-100">
              <Flame className="w-5 h-5" data-id="element-101" />
              Obtener todo por 12 USD ahora
            </Button>
          </div>
        </div>
      </div>
    </section>;
}